<template>
  <div id="video">
    <div id="video-main">
      <div id="video-main-wrap"> 
        <div id="box" ref="box">
          <video ref="video" class="videos" v-for="(item, idx) of videoSrc" :key="idx" :src="item" controls muted autoplay loop>
            {{ $t("role.playerWarning") }}
          </video>
        </div>
      </div>
      <img ref="leftBtn" id="video-left" src="../assets/images/video-left.png" @click.stop="nextFn"/>
      <img ref="rightBtn" id="video-right" src="../assets/images/video-right.png" @click.stop="preFn"/>
      <Download />
    </div>
  </div>
</template>

<script>
import Download from "@/components/Download.vue";

export default {
  components: {
    Download,
  },
  data(){
    return{
      activeIndex: 1,
      videoSrc:[
        require('../assets/video/video1.mp4'),
        require('../assets/video/video2.mp4'),
        require('../assets/video/video3.mp4'),
      ]
    }
  },
  methods: {
    preFn() {
      this.$refs.leftBtn.style.cursor = "pointer" 
      if(this.activeIndex==this.videoSrc.length){
        this.$refs.rightBtn.style.cursor = "not-allowed" 
        return
      }
      this.$refs.box.style.left = "-"+this.$refs.video[0].offsetWidth*this.activeIndex+++"px"
    },
    nextFn(){
      this.$refs.rightBtn.style.cursor = "pointer" 
      if(this.activeIndex==1){
        this.$refs.leftBtn.style.cursor = "not-allowed" 
        return
      }
      this.$refs.box.style.left = "-"+this.$refs.video[0].offsetWidth*(this.activeIndex-2)+"px"
      this.activeIndex--
    }
  },
};
</script>

<style scoped lang="scss">
#video-main{
  width: 100%;
  height: 100%;
  position: relative;
  background-image: url("../assets/images/video-back.png");
  background-repeat: no-repeat;
  background-size: 100%;
}
#video-main-wrap{
  width: 1364px;
  height: 615px;
  position: absolute;
  top: 90px;
  left: 285px;
  overflow: hidden;
}
#box{
  width: 4092px;
  height: 615px;
  position: absolute;
  top: 0;
  left: 0;
  transition: all 0.3s ease;
}
.videos{
  display: inline-block;
  width: 1364px;
  height: 615px;
}
#video-left{
  width: 181px;
  height: 207px;
  position: absolute;
  top: 300px;
  left: 90px;
  cursor: pointer;
}
#video-right{
  width: 181px;
  height: 207px;
  position: absolute;
  top: 300px;
  right: 90px;
  cursor: pointer;
}
</style>
